import { useQuery } from "@tanstack/react-query";
import { useAuth } from "hooks";
import { Sale, SaleFilterData } from "models";
import { SalesService } from "services";

export const useSales = () => {
    const { isAdministrator } = useAuth();
	const { data: sales, isFetching, error } = useQuery({
		queryKey: ['sales'],
		queryFn: isAdministrator ? SalesService.getAll : SalesService.getAllForUser
	})

    const filterFunction = (items: Sale[], filterData: SaleFilterData) => {
		return items?.filter((sale: Sale) => {
			if (filterData.userId && sale.user?.id !== filterData.userId) {
				return false;
			}
			if (filterData.productId && sale.product?.id !== filterData.productId) {
				return false;
			}
			if (filterData.startDate && new Date(sale.timeStamp) <= filterData.startDate) {
				return false;
			}
			if (filterData.endDate && new Date(sale.timeStamp) >= filterData.endDate) {
				return false;
			}
			return true;
		});
	};
    return {
        sales,
        isFetching,
        error,
        filterFunction
    }
}